export default class Help {

  constructor() {}

  render() {

	  // Toggle chevron's on click
	  $('.accordion .accordion-content').click(function() {
	  	$(this).find('i:not(.fa-paper-plane), svg:not(.fa-paper-plane)').toggleClass('fa-chevron-down fa-chevron-up');
	  })

	  // Enable contact on recaptcha
	  function confirmedReCaptcha() {
	  	$('.disabled-send').addClass('d-none');
	  	$('.enabled-send').removeClass('d-none');
	  	$('.submit-help').attr('disabled', false);
	  }

 }

}